import {
  Box,
  Pagination,
  PaginationItem,
  PaginationProps,
  PaginationRenderItemParams,
  Typography,
} from '@mui/material';
import { memo } from 'react';
import { ArrowLeft1Icon, ArrowRight1Icon } from '~/assets/icons';
import styles from './BasePagination.module.scss';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { PAGE_LIMITED } from '~/utils/constants/common';
import BaseSelect from '~/components/common/base-select/BaseSelect';

const cx = classNames.bind(styles);

type BasePaginationProps = PaginationProps & {
  count?: number;
  totalItems?: number;
  pageIndex?: number;
  pageSize?: number;
  label?: string;
  onChangePageSize?: (value: number) => void;
};

const BasePagination = (props: BasePaginationProps) => {
  const { t } = useTranslation('admin/common');

  const { count, label, pageIndex, pageSize, totalItems, onChange, onChangePageSize, ...restProps } = props;

  return (
    <Box className='flex items-center justify-between bg-white rounded-b-xl px-6 py-5'>
      <Box className='flex items-center gap-4'>
        <Typography className='font-normal text-base text-[#161A1F] flex-1'>
          {t('total')}:
          <Typography component={'span'} className='text-base font-semibold text-[#C62828] mx-1'>
            {totalItems}
          </Typography>
          {label}
        </Typography>
        <Box className='w-[118px] border rounded-xl border-[#D7DEE7]'>
          <BaseSelect
            options={PAGE_LIMITED}
            value={pageSize}
            onChange={(event: any) => {
              onChangePageSize?.(event.target.value);
            }}
            renderSelected={(option: any) => (
              <Typography className='px-2 text-base'>
                {option.name}/{t('page').toLowerCase()}
              </Typography>
            )}
          />
        </Box>
      </Box>
      <Pagination
        className={cx('pagination-container')}
        variant='outlined'
        page={pageIndex}
        count={count}
        onChange={onChange}
        renderItem={(item: PaginationRenderItemParams) => (
          <PaginationItem slots={{ previous: ArrowLeft1Icon, next: ArrowRight1Icon }} {...item} />
        )}
        shape='rounded'
        {...restProps}
      />
      <Box className='flex items-center gap-3'>
        <Typography className='capitalize text-[#161A1F] text-base font-normal'>{t('page')}</Typography>
        <Box className='rounded-xl border border-[#D7DEE7] text-center h-[48px] leading-[48px] w-24 text-base text-[#161A1F]'>
          {pageIndex}
        </Box>
      </Box>
    </Box>
  );
};

export default memo(BasePagination);
